module.exports = __webpack_public_path__ + "img/Rosana-Silva.cb2cd13c.png";